export default (name, index = false) => () =>
  import(`components/${name}${index ? "/index" : ""}.vue`);



// WEBPACK FOOTER //
// ./src/router/lazyLoading.js